import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, provideZoneChangeDetection, NgZone } from '@angular/core';
import { AgGridModule } from "ag-grid-angular";
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpXhrBackend, HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { provideNgxWebstorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
//import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting

import { ChangePasswordService } from './change-password/change-password.service';
import { ForgotPasswordService } from './forgot-password/forgot-password.service';

import { CoreModule } from './core';
import { AppComponent } from './app.component';
import { AppRoutingModule, APP_ROUTING_COMPONENTS } from './app-routing.module';
import { RedirectModule } from './redirect/redirect.module';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbAppropriateUseModalContent } from './shared/components/modal/appropriate-use-modal.component';
import { NgbInitialPasswordResetModalContent } from './shared/components/modal/initial-password-reset-modal.component';
import { NgbSubstationEditModalContent } from './shared/components/modal/substation-edit-modal.component';
import { NgbTxoamonitorEditModalContent } from './shared/components/modal/txoamonitor-edit-modal.component';
import { NgbProgramRecipientModalContent } from './shared/components/modal/program-recipient-modal.component';
import { NgbAlarmRecipientModalContent } from './shared/components/modal/alarm-recipient-modal.component';
import { NgbDeleteModalContent } from './shared/components/modal/delete.component';
import { NgbEditCurtailmentModalContent } from './shared/components/modal/edit-curtailment-modal.component';
import { NgbNotificationMessagesEditComponent } from './shared/components/modal/notification-messages-edit-modal.component';
import { TestModalContent } from './shared/components/modal/test-modal.component';
import { ConfigService } from './shared/utils/config.service';
import { SettingsService } from './shared/services/settings.service';
import { DataStorageService } from './shared/services/data-storage.service';
import { AuthInterceptor } from './core/authentication/auth.interceptor';
import { GoogleChartsModule } from 'angular-google-charts';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
  declarations: [
    AppComponent,
    NgbAppropriateUseModalContent,
    NgbInitialPasswordResetModalContent,
    NgbSubstationEditModalContent,
    NgbTxoamonitorEditModalContent,
    NgbProgramRecipientModalContent,
    NgbAlarmRecipientModalContent,
    NgbDeleteModalContent,
    TestModalContent,
    NgbEditCurtailmentModalContent,
    NgbNotificationMessagesEditComponent,
    APP_ROUTING_COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    AgGridModule,
    ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        preventDuplicates: true
    }),
    //HttpClient,
    FormsModule,
    TreeViewModule,
    ReactiveFormsModule,
    NgbModule,
    DialogsModule,
    AppRoutingModule,
    RedirectModule,
    CoreModule,
    NgIdleKeepaliveModule.forRoot(),
    //    MomentModule,
    NgxSpinnerModule,
    GoogleChartsModule,
    QRCodeComponent
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    { provide: NgZone, useFactory: () => new NgZone({ enableLongStackTrace: false }) },
    provideHttpClient(withInterceptors([AuthInterceptor])),
    DatePipe,
    NgbActiveModal,
    NgbAppropriateUseModalContent,
    NgbInitialPasswordResetModalContent,
    NgbSubstationEditModalContent,
    NgbTxoamonitorEditModalContent,
    NgbProgramRecipientModalContent,
    NgbAlarmRecipientModalContent,
    NgbDeleteModalContent,
    NgbEditCurtailmentModalContent,
    NgbNotificationMessagesEditComponent,
    TestModalContent,
    ConfigService,
    SettingsService,
    DataStorageService,
    ChangePasswordService,
    ForgotPasswordService,
    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'SCE_Platform', separator: '|', caseSensitive: true }),
      withSessionStorage()
    ),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
